// Helpers for attributing sale amounts by tender, correctly splitting bills
// that were paid across multiple methods (Transaction.payments) instead of
// lumping the whole total onto the dominant paymentMethod.

import { PaymentMethod, Transaction } from '../types';

export type TenderTotals = Record<PaymentMethod, number>;

const empty = (): TenderTotals => ({ cash: 0, card: 0, digital: 0, credit: 0 });

// Total the given sales by tender. Split bills contribute per payment line;
// single-tender bills contribute their full total to their method.
export function tenderTotals(sales: Transaction[]): TenderTotals {
  const out = empty();
  for (const s of sales) {
    if (s.payments && s.payments.length > 1) {
      for (const p of s.payments) out[p.method] += p.amount;
    } else {
      out[s.paymentMethod] = (out[s.paymentMethod] ?? 0) + s.total;
    }
  }
  return out;
}

// Amount of a single sale paid by one tender (handles split + single bills).
export function tenderOf(sale: Transaction, method: PaymentMethod): number {
  if (sale.payments && sale.payments.length > 1) {
    return sale.payments.filter((p) => p.method === method).reduce((a, p) => a + p.amount, 0);
  }
  return sale.paymentMethod === method ? sale.total : 0;
}
